import { ScreenSize } from 'glints-aries';
import styled from 'styled-components';

export const navbarMinHeight = '64px';
export const desktopNavbarHeight = '56px';
export const NAVBAR_Z_INDEX = 10;
export const NavbarWrapper = styled.div<{ top?: number }>`
  position: sticky;
  top: ${({ top }) => top || 0}px;
  left: 0;
  min-height: ${navbarMinHeight};

  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: ${NAVBAR_Z_INDEX};
  width: 100%;
  background-color: white;

  box-sizing: border-box;

  @media (min-width: ${ScreenSize.tablet}px) {
    min-height: ${desktopNavbarHeight};
  }
`;
